/** API role codes. "Admin" is the Portal User label, not Django superuser. */
export const USER_TYPES = {
  portalUser: 'PORTAL_USER',
  customerAccountManager: 'CUSTOMER_ACCOUNT_MANAGER',
  appUser: 'APP_USER',
} as const;

export type UserType = typeof USER_TYPES[keyof typeof USER_TYPES];

export const USER_TYPE_LABELS: Record<UserType, string> = {
  PORTAL_USER: 'Admin',
  CUSTOMER_ACCOUNT_MANAGER: 'Customer Account Manager',
  APP_USER: 'App User',
};

// These are the roles the portal's Users endpoint lists and can assign.
export const MANAGED_USER_TYPES = [USER_TYPES.portalUser, USER_TYPES.customerAccountManager] as const;
export const MANAGED_USER_TYPE_OPTIONS = MANAGED_USER_TYPES.map(value => ({
  value,
  label: USER_TYPE_LABELS[value],
}));

export function userTypeLabel(value: string): string {
  return USER_TYPE_LABELS[value as UserType] ?? value;
}
